module.exports = __webpack_public_path__ + "assets/img/2005.70ca1ece.png";